import { DataTablePaginate } from '@/common/ui/table/data-table-paginate'
import { DataTableResetFilter } from '@/common/ui/table/data-table-reset-filter'
import { DataTableSearch } from '@/common/ui/table/data-table-search'
import { OperatorDataResponse } from '../../types'
import { ColumnDef } from '@tanstack/react-table'

interface OperatorListProps {
	data: OperatorDataResponse[]
	total: number
	columns: ColumnDef<OperatorDataResponse>[]
	isLoading?: boolean
}

export default function OperatorTable({
	data,
	total,
	columns,
	isLoading = false,
}: OperatorListProps) {
	return (
		<div className="space-y-4">
			<div className="flex flex-wrap items-center gap-4">
				<DataTableSearch placeHolder={'ชื่อผู้ใช้งาน'} />

				<DataTableResetFilter />
			</div>

			<DataTablePaginate
				columns={columns}
				data={data}
				totalItems={total}
				isLoading={isLoading}
			/>
		</div>
	)
}
